import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import Glide from '@glidejs/glide';


@Component({
  selector: 'app-global-leaders',
  templateUrl: './global-leaders.component.html',
  styleUrls: ['./global-leaders.component.scss']
})
export class GlobalLeadersComponent implements OnInit, AfterViewInit {

  isBrowser = false;
  @Input() title: string = 'Vertraut von weltweit führenden Unternehmen';
  @Input() clientLogos: any[] = [];

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  defaultClientLogos = [
    {
      src: 'assets/images/clients/mit.svg',
      width: 62,
      height: 33,
      alt: 'Massachusetts Institute of Technology (MIT) logo',
      class: 'filter'
    },
    {
      src: 'assets/images/clients/IEEE.svg',
      width: 110,
      height: 32,
      alt: 'IEEE logo',
      class: 'filter'
    },
    {
      src: 'assets/images/clients/stanford.svg',
      width: 99,
      height: 44,
      alt: 'Stanford University logo',
      class: 'filter'
    },
    {
      src: 'assets/images/clients/wiley.svg',
      width: 114,
      height: 28,
      alt: 'Wiley logo',
      class: 'filter'
    },
    {
      src: 'assets/images/clients/pfizer.svg',
      width: 118,
      height: 48,
      alt: 'Pfizer logo',
      class: 'filter'
    },
    {
      src: 'assets/images/clients/abbott.svg',
      width: 126,
      height: 32,
      alt: 'Abbott logo',
      class: 'filter'
    },
    {
      src: 'assets/images/clients/princeton-white.svg',
      width: 132,
      height: 36,
      alt: 'Princeton University logo',
      class: ''
    }
  ];

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (!this.clientLogos || this.clientLogos.length === 0) {
      this.clientLogos = this.defaultClientLogos;
    }
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      setTimeout(() => {
        new Glide('#leadersSlider', {
          type: 'carousel',
          perView: 7,
          gap: 10,
          autoplay: 3000,
          breakpoints: {
            1024: { perView: 6 },
            768: { perView: 5 },
            480: { perView: 2 }
          }
        }).mount();
      }, 0); // You can increase this if needed
    }
  }

}
